import React, {Component} from "react";

// reactstrap components
import { Card, CardFooter, CardHeader, CardTitle, CardBody, Row, Col, Form, FormGroup, Button } from "reactstrap";

// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import axios from "axios";
import { api_link } from "siteConfig";
import { SHA256 } from "crypto-js";

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            old_password: '',
            new_password: '',
            confirm_password: ''
        };
    }

    passwordCheck = () => {
        let password = this.state.new_password;
        let confirmPassword = this.state.confirm_password;
        if(password !== confirmPassword) {
            //set confirm password input to red border
            document.getElementById("changePasswordForm").elements["confirmPassword"].style.borderColor = "red";
            //add label below confirm password input
            // if label does not exisit
            if(document.getElementById("passwordCheck") === null) {
                let label = document.createElement("label");
                label.innerHTML = "Passwords do not match";
                label.style.color = "red";
                label.style.fontSize = "12px";
                label.id = "passwordCheck";
                document.getElementById("changePasswordForm").elements["confirmPassword"].parentNode.appendChild(label);
            }
            return false
        }
        else {
            //set confirm password input to green border
            document.getElementById("changePasswordForm").elements["confirmPassword"].style.borderColor = "green";
            //remove label below confirm password input
            if(document.getElementById("passwordCheck") !== null) {
                document.getElementById("passwordCheck").remove();
            }
            return true
        }
    }

    submit = async (e) => {    
        e.preventDefault();
        
        let url = 'https://'+api_link+'supplier_portal/changePassword';

        let salt = 'V8e0BZFb)QUR';

        let old_password = this.state.old_password;
        let new_password = this.state.new_password;
        let confirm_password = this.state.confirm_password; 

        old_password = SHA256(old_password+salt).toString();
        new_password = SHA256(new_password+salt).toString();
        confirm_password = SHA256(confirm_password+salt).toString();
    
        await axios({
            method: "post",
            url: url,
            data: {
                "referurl": url,
                "var1": sessionStorage.getItem("user_id"),
                "var2": old_password,
                "var3": new_password,
                "var4": confirm_password
            },
            timeout: 5000,
            headers: {
                "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                // "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json"
            }
        }).then(resp => {
            
            if(resp.data.message === 'Password changed successfully') {
                this.setState({old_password: '', new_password: '', confirm_password: ''});
                //disable submit button
                document.getElementById("changePasswordForm").elements["confirmPassword"].style.borderColor = "";
                document.getElementById("changePasswordForm").elements["confirmPassword"].value = "";
                document.getElementById("changePasswordForm").elements["submitPassword"].disabled = true;
                document.getElementById("changePasswordForm").elements["currentPassword"].value = "";
                document.getElementById("changePasswordForm").elements["newPassword"].value = "";
                // add a label below the confirm password input
                if(document.getElementById("passwordCheck") === null) {
                    let label = document.createElement("label");
                    label.innerHTML = "Password Updated!";
                    label.style.color = "green";
                    label.style.fontSize = "12px";
                    label.id = "passwordCheck";
                    document.getElementById("changePasswordForm").elements["confirmPassword"].parentNode.appendChild(label);
                }
            }
            else {
                alert(resp.data.message);
            }

        }).catch(err => {
            console.log(err)
        });

    }

    render() {
        return (
        <>
            <PanelHeader
                size="lg"
                content={image}
            />
            <div className="content" style={{marginTop: '-40px'}}>
            <Row>
                <Col xs={12} md={12}>
                    <Form id="changePasswordForm" onSubmit={(e) => this.submit(e)}>
                        <Card>
                            <CardHeader>
                                {/* <h5 className="card-category">Stats / Other Bits</h5> */}
                                <CardTitle tag="h4" className="card-category">Change Password</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <FormGroup className={`has-label`}>
                                    <label>
                                        Current Password
                                    </label>
                                    <input
                                        className="form-control"
                                        name="currentPassword"
                                        placeholder="Current Password"
                                        type="password"
                                        onChange={(e) => this.setState({old_password: e.target.value})}
                                    />
                                </FormGroup>
                                <FormGroup className={`has-label`}>
                                    <label>
                                        New Password
                                    </label>
                                    <input
                                        className="form-control"
                                        name="newPassword"
                                        placeholder="New Password"
                                        type="password"
                                        onChange={(e) => this.setState({new_password: e.target.value})}
                                    />
                                </FormGroup>
                                <FormGroup className={`has-label`}>
                                    <label>
                                        Confirm Password
                                    </label>
                                    <input
                                        className="form-control"
                                        name="confirmPassword"
                                        placeholder="Confirm Password"
                                        type="password"
                                        onChange={(e) => { this.setState({confirm_password: e.target.value}); this.passwordCheck(); }}
                                    />
                                </FormGroup>
                                <Button 
                                    className="btn-fill btn-round" 
                                    color="success" 
                                    type="submit"
                                    name="submitPassword"
                                    disabled={
                                        this.state.old_password === '' ||
                                        this.state.new_password === '' ||
                                        this.state.confirm_password === '' ||
                                        !this.passwordCheck() ? true : false
                                    }
                                    >
                                    Change Password
                                </Button>
                            </CardBody>
                            <CardFooter>

                            </CardFooter>
                        </Card>
                    </Form>
                </Col>
            </Row>
            </div>
        </>
        );
    }
}

export default ChangePassword;